<template>
  <b-modal
    id="operation-modifier-confirm-modal"
    v-model="active"
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-label="Atualizar CAP"
    has-modal-card
    trap-focus
    :on-cancel="close"
    aria-modal>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-body">
        <div class="modal-card-title modal-title">
          Atenção
        </div>
        <a
          class="close-modal delete"
          type="button"
          @click="close()" />
      </header>
      <section class="modal-card-body">
        <p>
          O CAP será modificado com os seguintes valores.
        </p>
        <p>
          <strong>Parcela inicial:</strong> {{ firstPayment }} <br>
          <strong>Parcela final:</strong> {{ lastPayment }} <br>
          <strong>CAP:</strong> {{ (newInflationaryUpperBound).toFixed(2) }}%
        </p>
        <p class="text-align-center">
          Você tem certeza que quer continuar?
        </p>
        <div class="buttons is-pulled-right">
          <b-button
            id="operation-modifier-modal-button-no"
            class="button is-button-secondary"
            label="Não"
            rounded
            @click="close()" />
          <b-button
            id="operation-modifier-modal-button-continue"
            label="Continuar"
            rounded
            class="button is-button-primary"
            @click="confirm()" />
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    firstPayment: {
      type: Number,
      required: true
    },
    lastPayment: {
      type: Number,
      required: true
    },
    newInflationaryUpperBound: {
      type: Number,
      required: true
    },
    isComponentModalActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {

    };
  },
  computed: {
    active() {
      return this.$props.isComponentModalActive;
    }
  },
  methods: {
    confirm() {
      this.$emit('applyInflationaryUpperBoundChanges');
    },
    close() {
      this.$emit('cancelModal');
    }
  }
};
</script>

<style scoped>
.modal-card-body p {
  padding-bottom: 1rem;
}
.pad-right {
  margin-right: 1rem;
}
.modal-card-body {
  position: relative;
}
.modal-card-body .close-modal {
  position: absolute;
  right: 20px;
  top:20px;
  width: 40px;
}
.modal-title {
  color: #00CCD1;
  font-weight:500;
}
</style>
